/****************************
*   
*   Pantomime Paty (c) 2022
*
*   Author: Oliver Borner 
*   oliverborner@gmail.com
*
*****************************/


<template>
	<div class="howtoplay-container">
			
		<div class="faq-item">
			<div class="faq-item-card">
				<h4 class="pb-4">Wie wird gespielt?</h4>
				<img src="../assets/images/how2/how1.svg" width="120">
				<p>Stelle die angezeigten Begriffe in der vorgegebenen Zeit pantomimisch dar. 
				Für jeden erratenen Begriff erhältst du einen Punkt. 
				Tippe dazu einfach den Begriff an.</p>
				<p>Haben mehrer die App, könnt ihr die erhaltenen Punkte am Ende vergleichen und den Gewinner festlegen, 
					natürlich könnt ihr auch nur mit einem Gerät spielen und es einfach weiterreichen.</p>
			</div>

			<div class="faq-item-card">
				<h4 class="pb-4">Kategorienauswahl</h4>
				<img src="../assets/images/how2/how2.svg" class="fl-right" width="150">
				<p>Du kannst einfach das Spiel mit einer vorausgewählten Kategorienauswahl starten oder
					dir selbst deine Lieblingskategorien zusammenstellen. Es kann wahlweise mit mehreren 
					Kategorien oder nur mit einer gespielt werden.
				</p>
			</div>

			<div class="faq-item-card">
				<h4 class="pb-4">Einstellungen</h4>
				<p>In den Einstellungen kannst du die verbleibende Zeit der 3 angezeigten Begriffe einstellen und die Sounds deaktivieren,
					dies kannst du auch während des Spiels in der rechten oberen Ecke tun.
				</p>
			</div>

			<button type="button" class="btn btn-success-howto" @click="$parent.modalHowToPlay = false; playSound('sounds/click2.mp3')">
				<span><b-icon-arrow-left scale="1.4"></b-icon-arrow-left></span>		
			</button>

		</div>

	</div>

</template>

<script>
  

  export default {

	methods:{
		playSound (sound) {
            if(this.$parent.hasSound){
                if(sound) {
                    var audio = new Audio(sound, {formats: [ "mp3" ], preload: true});
                    audio.play();
                }
            }
        },
	}
  }
</script>
